<template>
    <div class="emc_card px-4 py-4 list-item-component">
        <div class="vx-row">
            <div class="vx-col w-full flex sm:items-center sm:flex-row flex-col">
                <div class="flex w-full justify-between items-start">
                    <div style="width: 100%">
                        <div class="flex items-center mb-1">
                            <vs-row vs-sm="12" class="md:hidden">
                                <vs-col  vs-sm="12">
                                    <vs-chip class="mr-2 text-sm"  color="primary">{{item.discipline_name}}</vs-chip>
                                </vs-col>
                                <vs-col  vs-sm="12">
                                    <vs-chip v-if="itemLang" class="lang_chip"  color="warning">{{itemLang}}</vs-chip>
                                </vs-col>
                            </vs-row>
                            <vs-row vs-lg="12" class="hidden sm:inline-flex">
                                <vs-chip class="mr-2 text-sm"  color="primary">{{item.discipline_name}}</vs-chip>
                                <vs-chip v-if="itemLang" class="lang_chip"  color="warning">{{itemLang}}</vs-chip>
                            </vs-row>
                        </div>
                        <h5 class="todo-title">{{ item.name }}</h5>
                    </div>
                    <div style="width: 100%">
                        <div class="flex items-center">
                            <vs-icon class="mr-1" icon="access_time"></vs-icon>
                            <span>{{ $moment(item.created).format('LL') }}</span>
                        </div>
                        <div v-if="item.author_name" class="flex items-center author_block">
                            <span class="mr-2 author_label">{{$t('author')}}</span>
                            <div>{{item.author_name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <p class="mt-0 lg:mt-2 truncate">{{item.description}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        itemLang() {
            // Подставляем локализацию для поля язык
            if(this.$i18n.locale === 'ru') return this.item.language_name
            else return this.item[`language_name_${ this.$i18n.locale }`]
        }
    }
}
</script>

<style lang="scss">
.lang_chip{
    .text-chip{
        text-transform: capitalize;
    }
}
.emc_card{
    display: block;
    color: #2c2c2c;
}
@media only screen and (max-width: 900px) {
    .emc_card{
        .author_label{
            width: 100%;
            font-weight: 600;
        }
        .author_block{
            flex-wrap: wrap;
        }
        .items-start{
            display: block!important;
            .con-vs-chip{
                .text-chip{
                    font-size: 10px;
                }
            }
            .todo-title{
                margin-bottom: 10px!important;
            }
            .items-center{
                margin-bottom: 6px;
            }
        }
    }
}
</style>
